// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*** ESSENTIAL STYLES ***/
.sf-menu, .sf-menu * {
	margin: 0;
	padding: 0;
	list-style: none;
}
.sf-menu li {
	position: relative;
}
.sf-menu ul {
	position: absolute;
	display: none;
	top: 100%;
	left: 0;
	z-index: 99;
}
.sf-menu > li {
	float: left;
}
.sf-menu li:hover > ul,
.sf-menu li.sfHover > ul {
	display: block;
}

.sf-menu a {
	display: block;
	position: relative;
}
.sf-menu ul ul {
	top: 0;
	left: 100%;
}


/*** SKIN ***/
.sf-menu {
	float: left;
	margin-bottom: 1em;
}
.sf-menu ul {
	box-shadow: 2px 2px 6px rgba(0,0,0,.2);
	min-width: 12em; /* allow long menu items to determine submenu width */
	*width: 12em; /* no auto sub width for IE7, see white-space comment below */
}
.sf-menu a {
	/* border-left: 1px solid #fff; */
	/* border-top: 1px solid #dFeEFF; */ /* fallback colour must use full shorthand */
	/* border-top: 1px solid rgba(255,255,255,.5); */
	padding: .75em 1em;
	text-decoration: none;
	zoom: 1; /* IE7 */
}
.sf-menu a {
	color: black;
	font-weight: bold;
}
/* menu items */
.sf-menu li {
	background: white;
	white-space: nowrap; /* no need for Supersubs plugin */
	*white-space: normal; /* ...unless you support IE7 (let it wrap) */
	-webkit-transition: background .2s;
	transition: background .2s;
}
/* second level dropdown menu items */
.sf-menu ul li {
	background: white;
}
/* third level dropdown menu items */
.sf-menu ul ul li {
	background: white;
}
/* first level menu items hover */
.sf-menu li:hover,
.sf-menu li.sfHover {
	background: white;
	/* only transition out, not in */
	-webkit-transition: none;
	transition: none;
}

/*** arrows (for all except IE7) **/
/*.sf-arrows .sf-with-ul {*/
/*	padding-right: 2.5em;*/
/*	*padding-right: 1em; !* no CSS arrows for IE7 (lack pseudo-elements) *!*/
/*}*/
/*!* styling for both css and generated arrows *!*/
/*.sf-arrows .sf-with-ul:after {*/
/*	content: '';*/
/*	position: absolute;*/
/*	top: 50%;*/
/*	right: 1em;*/
/*	margin-top: -3px;*/
/*	height: 0;*/
/*	width: 0;*/
/*	!* order of following 3 rules important for fallbacks to work *!*/
/*	border: 5px solid transparent;*/
/*	border-top-color: #dFeEFF; !* edit this to suit design (no rgba in IE8) *!*/
/*	border-top-color: rgba(255,255,255,.5);*/
/*}*/
/*.sf-arrows > li > .sf-with-ul:focus:after,*/
/*.sf-arrows > li:hover > .sf-with-ul:after,*/
/*.sf-arrows > .sfHover > .sf-with-ul:after {*/
/*	border-top-color: white; !* IE8 fallback colour *!*/
/*}*/
/*!* styling for right-facing arrows *!*/
/*.sf-arrows ul .sf-with-ul:after {*/
/*	margin-top: -5px;*/
/*	margin-right: -3px;*/
/*	border-color: black;*/
/*	border-left-color: #dFeEFF; !* edit this to suit design (no rgba in IE8) *!*/
/*	border-left-color: rgba(255,255,255,.5);*/
/*}*/
/*.sf-arrows ul li > .sf-with-ul:focus:after,*/
/*.sf-arrows ul li:hover > .sf-with-ul:after,*/
/*.sf-arrows ul .sfHover > .sf-with-ul:after {*/
/*	border-left-color: greenyellow;*/
/*}*/
`, "",{"version":3,"sources":["webpack://./assets/src/ipha/superfish.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;CACC,SAAS;CACT,UAAU;CACV,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,aAAa;CACb,SAAS;CACT,OAAO;CACP,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;;CAEC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,kBAAkB;AACnB;AACA;CACC,MAAM;CACN,UAAU;AACX;;;AAGA,aAAa;AACb;CACC,WAAW;CACX,kBAAkB;AACnB;AACA;CACC,sCAAsC;CACtC,eAAe,EAAE,qDAAqD;EACtE,WAAY,EAAE,6DAA6D;AAC5E;AACA;CACC,iCAAiC;CACjC,mCAAmC,EAAE,4CAA4C;CACjF,gDAAgD;CAChD,kBAAkB;CAClB,qBAAqB;CACrB,OAAO,EAAE,QAAQ;AAClB;AACA;CACC,YAAY;CACZ,iBAAiB;AAClB;AACA,eAAe;AACf;CACC,iBAAiB;CACjB,mBAAmB,EAAE,iCAAiC;EACtD,mBAAoB,EAAE,4CAA4C;CAClE,kCAAkC;CAClC,0BAA0B;AAC3B;AACA,qCAAqC;AACrC;CACC,iBAAiB;AAClB;AACA,oCAAoC;AACpC;CACC,iBAAiB;AAClB;AACA,iCAAiC;AACjC;;CAEC,iBAAiB;CACjB,gCAAgC;CAChC,wBAAwB;CACxB,gBAAgB;AACjB;;AAEA,mCAAmC;AACnC,2BAA2B;AAC3B,yBAAyB;AACzB,2EAA2E;AAC3E,IAAI;AACJ,kDAAkD;AAClD,iCAAiC;AACjC,gBAAgB;AAChB,uBAAuB;AACvB,aAAa;AACb,eAAe;AACf,qBAAqB;AACrB,cAAc;AACd,aAAa;AACb,oEAAoE;AACpE,kCAAkC;AAClC,8EAA8E;AAC9E,2CAA2C;AAC3C,IAAI;AACJ,6CAA6C;AAC7C,6CAA6C;AAC7C,8CAA8C;AAC9C,sDAAsD;AACtD,IAAI;AACJ,wCAAwC;AACxC,oCAAoC;AACpC,qBAAqB;AACrB,uBAAuB;AACvB,wBAAwB;AACxB,+EAA+E;AAC/E,4CAA4C;AAC5C,IAAI;AACJ,8CAA8C;AAC9C,8CAA8C;AAC9C,+CAA+C;AAC/C,mCAAmC;AACnC,IAAI","sourcesContent":["/*** ESSENTIAL STYLES ***/\n.sf-menu, .sf-menu * {\n\tmargin: 0;\n\tpadding: 0;\n\tlist-style: none;\n}\n.sf-menu li {\n\tposition: relative;\n}\n.sf-menu ul {\n\tposition: absolute;\n\tdisplay: none;\n\ttop: 100%;\n\tleft: 0;\n\tz-index: 99;\n}\n.sf-menu > li {\n\tfloat: left;\n}\n.sf-menu li:hover > ul,\n.sf-menu li.sfHover > ul {\n\tdisplay: block;\n}\n\n.sf-menu a {\n\tdisplay: block;\n\tposition: relative;\n}\n.sf-menu ul ul {\n\ttop: 0;\n\tleft: 100%;\n}\n\n\n/*** SKIN ***/\n.sf-menu {\n\tfloat: left;\n\tmargin-bottom: 1em;\n}\n.sf-menu ul {\n\tbox-shadow: 2px 2px 6px rgba(0,0,0,.2);\n\tmin-width: 12em; /* allow long menu items to determine submenu width */\n\t*width: 12em; /* no auto sub width for IE7, see white-space comment below */\n}\n.sf-menu a {\n\t/* border-left: 1px solid #fff; */\n\t/* border-top: 1px solid #dFeEFF; */ /* fallback colour must use full shorthand */\n\t/* border-top: 1px solid rgba(255,255,255,.5); */\n\tpadding: .75em 1em;\n\ttext-decoration: none;\n\tzoom: 1; /* IE7 */\n}\n.sf-menu a {\n\tcolor: black;\n\tfont-weight: bold;\n}\n/* menu items */\n.sf-menu li {\n\tbackground: white;\n\twhite-space: nowrap; /* no need for Supersubs plugin */\n\t*white-space: normal; /* ...unless you support IE7 (let it wrap) */\n\t-webkit-transition: background .2s;\n\ttransition: background .2s;\n}\n/* second level dropdown menu items */\n.sf-menu ul li {\n\tbackground: white;\n}\n/* third level dropdown menu items */\n.sf-menu ul ul li {\n\tbackground: white;\n}\n/* first level menu items hover */\n.sf-menu li:hover,\n.sf-menu li.sfHover {\n\tbackground: white;\n\t/* only transition out, not in */\n\t-webkit-transition: none;\n\ttransition: none;\n}\n\n/*** arrows (for all except IE7) **/\n/*.sf-arrows .sf-with-ul {*/\n/*\tpadding-right: 2.5em;*/\n/*\t*padding-right: 1em; !* no CSS arrows for IE7 (lack pseudo-elements) *!*/\n/*}*/\n/*!* styling for both css and generated arrows *!*/\n/*.sf-arrows .sf-with-ul:after {*/\n/*\tcontent: '';*/\n/*\tposition: absolute;*/\n/*\ttop: 50%;*/\n/*\tright: 1em;*/\n/*\tmargin-top: -3px;*/\n/*\theight: 0;*/\n/*\twidth: 0;*/\n/*\t!* order of following 3 rules important for fallbacks to work *!*/\n/*\tborder: 5px solid transparent;*/\n/*\tborder-top-color: #dFeEFF; !* edit this to suit design (no rgba in IE8) *!*/\n/*\tborder-top-color: rgba(255,255,255,.5);*/\n/*}*/\n/*.sf-arrows > li > .sf-with-ul:focus:after,*/\n/*.sf-arrows > li:hover > .sf-with-ul:after,*/\n/*.sf-arrows > .sfHover > .sf-with-ul:after {*/\n/*\tborder-top-color: white; !* IE8 fallback colour *!*/\n/*}*/\n/*!* styling for right-facing arrows *!*/\n/*.sf-arrows ul .sf-with-ul:after {*/\n/*\tmargin-top: -5px;*/\n/*\tmargin-right: -3px;*/\n/*\tborder-color: black;*/\n/*\tborder-left-color: #dFeEFF; !* edit this to suit design (no rgba in IE8) *!*/\n/*\tborder-left-color: rgba(255,255,255,.5);*/\n/*}*/\n/*.sf-arrows ul li > .sf-with-ul:focus:after,*/\n/*.sf-arrows ul li:hover > .sf-with-ul:after,*/\n/*.sf-arrows ul .sfHover > .sf-with-ul:after {*/\n/*\tborder-left-color: greenyellow;*/\n/*}*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
